//deps
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { TurboPaymentVariant } from "@swiggy-private/payment-client";

//helpers
import { isCartTotalZero } from "./CartItemRenderer";

export const isTurboPaymentEnabled = (cartResponse: ReviewedCart | null, isTurboPayWidgetHidden: boolean) => {
    // Turbo payment is now supported for accessibility (TalkBack/VoiceOver) users, so we no
    // longer gate it behind the `accessibility-enabled` header. The widget itself is keyboard
    // and screen-reader operable.
    return !isTurboPayWidgetHidden && !isCartTotalZero(cartResponse);
};

export const isTurboPayDiscountValueEnabled = (cartResponse: ReviewedCart | null) => {
    return cartResponse?.data?.turbo_pay_discount_value_enabled ?? false;
};

export const getTurboPaymentVariantForCart = (isQuickCheckoutEnabled: boolean): TurboPaymentVariant =>
    isQuickCheckoutEnabled ? TurboPaymentVariant.QUICK_CHECKOUT : TurboPaymentVariant.DEFAULT;
